import { type Groups } from '@atlaskit/tokens';

import type { TokenListColumns } from './types';

/**
 * Returns an array of column names to display corresponding to the token group provided
 */
export const getTokenListColumns: (group?: Groups) => TokenListColumns = (
	group?: Groups,
): TokenListColumns => {
	switch (group) {
		case 'shape':
			return [{ label: 'Token and description' }, { label: 'Value' }];
		case 'spacing':
			return [{ label: 'Token' }, { label: 'Value' }];
		case 'typography':
		case 'fontWeight':
		case 'fontFamily':
			return [{ label: 'Token and description' }, { label: 'Preview', width: 'extra-large' }];
		case 'motion':
		case 'motionDuration':
		case 'motionEasing':
		case 'motionKeyframe':
		case 'motionProperty':
			return [{ label: 'Token and description' }, { label: 'Value', width: 'extra-large' }];
		default:
			break;
	}

	const width = group === 'shadow' ? 'extra-large' : 'large';
	return [
		{ label: 'Token and description' },
		{ label: 'Light value', forceTheme: { colorMode: 'light' }, width },
		{ label: 'Dark value', forceTheme: { colorMode: 'dark' }, width },
	];
};
